import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FiCalendar } from 'react-icons/fi';
import '../stylesheets/components/DateFilter.css';

const DateFilter = ({ onDateRangeChange, selectedOption, dateRange }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [tempDateRange, setTempDateRange] = useState(dateRange || { startDate: '', endDate: '' });
  const [previousDateRange, setPreviousDateRange] = useState(dateRange || { startDate: '', endDate: '' });
  const [currentActive, setCurrentActive] = useState('allTime');

  const handleAllTimeClick = () => {
    if (currentActive !== 'allTime') {
      onDateRangeChange('allTime', null);
      setCurrentActive('allTime');
      setIsDropdownOpen(false);
    }
  };

  const handleDateRangeSubmit = () => {
    if (tempDateRange.startDate && tempDateRange.endDate 
      && (tempDateRange.startDate !== previousDateRange.startDate 
      || tempDateRange.endDate !== previousDateRange.endDate)) 
    {
      onDateRangeChange('dateRange', tempDateRange);
      setPreviousDateRange(tempDateRange);
      setCurrentActive('dateRange');
      setIsDropdownOpen(false);
    }
  };

  const handleDateRangeToggle = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <div className="date-filter-container">
      <button
        className={`filter-button ${selectedOption === 'allTime' ? 'active' : ''}`}
        onClick={handleAllTimeClick}
      >
        All Time&nbsp;
        <span className="dropdown-arrow">▼</span>
      </button>

      <span className="filter-separator">or</span>

      <div className="date-range-container">
        <button
          className={`filter-button date-range-button ${selectedOption === 'dateRange' ? 'active' : ''}`}
          onClick={handleDateRangeToggle}
        >
          {selectedOption === 'dateRange' && dateRange?.startDate && dateRange?.endDate
            ? `${formatDate(dateRange.startDate)} - ${formatDate(dateRange.endDate)}`
            : 'Select date range'
          }
          <FiCalendar size={16} />
        </button>

        {isDropdownOpen && (
          <div className="date-picker-dropdown">
            <div className="date-picker-content">
              <div className="date-input-group">
                <label htmlFor="from-date-input">From:</label>
                <input
                  id="from-date-input"
                  type="date"
                  value={tempDateRange.startDate || ''}
                  onChange={(e) => setTempDateRange({ ...tempDateRange, startDate: e.target.value })}
                />
              </div>
              <div className="date-input-group">
                <label htmlFor="to-date-input">To:</label>
                <input
                  id="to-date-input"
                  type="date"
                  value={tempDateRange.endDate || ''}
                  onChange={(e) => setTempDateRange({ ...tempDateRange, endDate: e.target.value })}
                />
              </div>
              <div className="date-picker-actions">
                <button
                  className="apply-button"
                  onClick={handleDateRangeSubmit}
                  disabled={!tempDateRange.startDate || !tempDateRange.endDate || 
                    (tempDateRange.startDate === previousDateRange.startDate && tempDateRange.endDate === previousDateRange.endDate)}
                >
                  Apply
                </button>
                <button
                  className="cancel-button"
                  onClick={() => setIsDropdownOpen(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

DateFilter.propTypes = {
  onDateRangeChange: PropTypes.func.isRequired,
  selectedOption: PropTypes.string.isRequired,
  dateRange: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string,
  }),
};

export default DateFilter;
